'use client';

import { FC } from 'react';

import { useAtomValue } from 'jotai';

import { userIdAtom } from '@core/Atoms/User/UserId.atom';
import Button from '@gds/Button/Button';
import { ctaClickedToEvent } from '@tracking/Schemas/CtaClicked/CtaClickedToEvent';
import { userContextToEvent } from '@tracking/Schemas/UserContext/UserContextToEvent';
import { trackCustomEvent } from '@tracking/Utils/TrackCustomEvent';

import { EvSpecsMessages } from './EvSpecs.messages';

import styles from './EvSpecs.module.css';

type Props = {
  strings: EvSpecsMessages;
};

export const EvSpecsCompareButton: FC<Props> = ({ strings }: Props) => {
  const userId = useAtomValue(userIdAtom);
  const showModal = () => {
    document.body.setAttribute('data-is-ev-compare-modal-open', 'true');

    const ctaEventObj = {
      ctaType: 'button',
      ctaWording: strings.compareButton,
      ctaLocation: 'ev_specs_pdp',
      targetUrl: window.location.href,
    };

    const userData = { userId, values: {} };
    const event = ctaClickedToEvent(ctaEventObj);
    const userEvent = userContextToEvent(userData);

    trackCustomEvent({ event, context: [userEvent] });
  };

  return (
    <div className={styles.compareButtonWrapper}>
      <Button
        className={styles.compareButton}
        variant="outlined"
        onClick={showModal}
        data-test-id="tco-compare-button"
      >
        {strings.compareButton}
      </Button>
    </div>
  );
};
